<template>
    <v-card :flat="flat"
            dark ma-0
            pa-0
            style="height: 100%; width: 100%;"
            class="text-center"
    >
        <v-list-item>
            <v-list-item-content>
                <v-avatar size="128">
                    <img :src="model.avatar" alt="avatar"/>
                </v-avatar>
            </v-list-item-content>
        </v-list-item>
        <v-list-item three-line>
            <v-list-item-content class="align-center">
                <v-list-item-title class="mb-1 align-center" style="font-size: 2.5rem!important;">{{model.name}}
                </v-list-item-title>
                <v-list-item-subtitle>{{model.hiddenEmail}}</v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
        <v-card-actions>
        </v-card-actions>
    </v-card>
</template>

<script>
	export default {
		name: "PersonCard",
        props: {
			model: Object,
            flat: Boolean
        }
	}
</script>

<style scoped>

</style>
